import { sql } from 'drizzle-orm';
import { real, uuid, customType } from 'drizzle-orm/pg-core';
import { DateTime } from 'luxon';
export const isoTimestamp = customType({
    dataType() {
        return 'timestamp with time zone';
    },
    fromDriver(value) {
        // Try SQL format first
        const sqlFormat = DateTime.fromSQL(value);
        if (sqlFormat.isValid) {
            return sqlFormat.toISO();
        }
        // Then try ISO format
        const isoFormat = DateTime.fromISO(value);
        if (isoFormat.isValid) {
            return isoFormat.toISO();
        }
        // Return original value
        return value;
    },
    toDriver(value) {
        return DateTime.fromISO(value).toSQL();
    },
});
export const tableBase = {
    id: uuid('id').notNull(),
    createdAt: isoTimestamp('created_at').default(sql `now()`),
    updatedAt: isoTimestamp('updated_at'),
};
// In theory would be better if this was a "numeric" in order to not lose precision..
export const sortOrder = real('sort_order').notNull();
export const sortOrderNullable = real('sort_order');
//# sourceMappingURL=utils.js.map